import { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react'; // Importando do lucide-react
import { CollapsibleTrigger } from '@radix-ui/react-collapsible'; // Importando explicitamente
import { Button } from '@/components/ui/button';

interface CollapsibleSectionHeaderProps {
  title: string;
  icon?: ReactNode;
}

function BlurHeader({children, ...props}: { children: React.ReactNode } & React.HTMLAttributes<HTMLDivElement>) {
  const isChrome = typeof navigator !== 'undefined' && /chrome/i.test(navigator.userAgent);
  const className = `
    sticky top-0 z-10 group flex items-center justify-between px-4 pb-1 hover:cursor-pointer
    ${isChrome ? "bg-secondary/30 backdrop-blur-3xl" : "bg-secondary" }
  `;

  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}

export const CollapsibleSectionHeader = ({ title, icon }: CollapsibleSectionHeaderProps) => {
  return (
    <CollapsibleTrigger asChild>
      <BlurHeader>
        <h2 className="text-base flex items-center gap-3 font-semibold text-foreground">
          {title}
          {icon}
        </h2>
        <Button variant="ghost" size="sm" className="text-muted-foreground group">
          <ChevronDown className="h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180" />
        </Button>
      </BlurHeader>
    </CollapsibleTrigger>
  );
};